module.exports = [
  '$scope',
  'ngDroUAA',
  'ngToast',
  '$state',
  '$sessionStorage',
  function ($scope, ngDroUAA, ngToast, $state, $sessionStorage) {
    $scope.active = 'login';

    $scope.switch = function (formName) {
      $scope.active = formName;
    };

    $scope.login = function () {
      ngDroUAA
        .login($scope.loginData.username, $scope.loginData.password)
        .then(function (login) {
          ngDroUAA.Profile.get()
            .then(function (profile) {
              $sessionStorage.profile = profile.data;
              //$state.go('main');
              var redirectUrl = sessionStorage.getItem('redirectUrl');

              if (redirectUrl) {
                $state.go(redirectUrl);
                sessionStorage.removeItem('redirectUrl');
              } else {
                $state.go('situation-record-index');
              }
            })
            .catch(function (reason) {
              ngToast.danger('Errore nel recuperare le informazioni utente');
            });
        })
        .catch(function (reason) {
          ngToast.danger('Credenziali errate');
        });
    };

    $scope.loginData = {
      username: null,
      password: null,
    };

    $scope.registerData = {
      username: null,
      password: null,
      email: null,
      confirmPassword: null,
    };
  },
];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-core/components/login/loginCtrl.js
// module id = 310
// module chunks = 0